import type { C2EddyLoadRunResult } from '../api/types';

const readCount = (value: unknown): number | undefined => (typeof value === 'number' ? value : undefined);

/**
 * Итог прогона загрузки периода из результата его задачи.
 *
 * Результат задачи приходит словарём без описанной формы: без любого из счётчиков итог не
 * собирается вовсе — неполный показал бы недостающее нулём.
 */
export const readC2EddyLoadRunResult = (
  results: Record<string, unknown> | null | undefined,
): C2EddyLoadRunResult | undefined => {
  const created = readCount(results?.created);
  const updated = readCount(results?.updated);
  const errors = readCount(results?.errors);
  const imagesUnavailable = readCount(results?.imagesUnavailable);
  if (created === undefined || updated === undefined || errors === undefined || imagesUnavailable === undefined) {
    return undefined;
  }

  return { created, updated, errors, imagesUnavailable };
};
